import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GeckoLoadingService, Tooltip, OverlayTrigger } from 'ui';
import GeckoPagination from 'services/gecko-pagination';
import GeckoLocation from 'services/gecko-location';

import CustomFieldEditModal from './components/CustomFieldEditModal';

import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import {
  GECKO_CONSTS,
  GeckoCardTable,
  GeckoModalService,
  GeckoToastService,
  GeckoDialogService,
} from 'ui';

import 'react-phone-number-input/style.css';
import ReorderArrowControls from '../../components/ReorderArrowControls';
import GeckoFeatures from 'services/gecko-features';
import GeckoStore from 'services/gecko-store';

const getOptionsUsedIfSelectType = ({ type, id }) => {
  if (
    type === GECKO_CONSTS.FIELD_TYPE_SELECT ||
    type === GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
  ) {
    return GeckoRequest.get(`/fields/workflow-options/${id}`);
  }
  return Promise.resolve([]);
};

class CustomFields extends Component {
  UNSAFE_componentWillMount() {
    this.typeMap = {};
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_TEXT] = 'Single Line Text';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_TEXTAREA] = 'Multiple Line Text';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_EMAIL] = 'Email';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_TELEPHONE] = 'Telephone';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_DATE] = 'Date';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_NUMBER] = 'Number';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI] = 'Multiple Choice';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_SELECT] = 'Single Choice';
    this.typeMap[GECKO_CONSTS.FIELD_TYPE_DISPLAY] = 'Display Statement';
  }

  canShowSmartContext =
    GeckoStore.redux.get('appState.isSupport') && // Temporary - will be removed soon
    GeckoFeatures.can('ai-engine');
  colWidth = this.canShowSmartContext ? '20%' : '25%';
  cols = [
    {
      render: (v, row, col, i) => {
        let suffix = 'lock-alt';
        if (row.custom_field) {
          suffix = 'unlock-alt';
        }

        return (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={`custom-fields-lock-${i}`}>
                {row.custom_field ? 'Can be deleted' : 'Cannot be deleted'}
              </Tooltip>
            }
          >
            <span
              className={`far fa-${suffix}`}
              id={`custom-fields-lock-${i}`}
            ></span>
          </OverlayTrigger>
        );
      },
    },
    {
      key: 'label',
      name: 'Label',
      sortable: 'label',
      width: this.colWidth,
    },
    {
      key: 'friendlyType',
      sortable: 'type',
      name: 'Type',
      width: this.colWidth,
    },
    {
      key: 'key',
      sortable: 'key',
      name: 'Key',
      width: this.colWidth,
    },
    {
      key: 'required_for_sync',
      sortable: 'required_for_sync',
      name: 'Required For Sync',
      width: this.colWidth,
      render: (value) => (value ? 'Yes' : '-'),
    },
    this.canShowSmartContext && {
      key: 'smart_context_enabled',
      sortable: 'smart_context_enabled',
      name: 'Smart Context Enabled',
      width: this.colWidth,
      render: (value) => (value ? 'Yes' : '-'),
    },
    {
      render: (v, row, col, i) => {
        const orders = this.props.fields.map((field) => field.order);
        const highestOrder = Math.max.apply(null, orders);
        let upCursor = 'pointer';
        let downCursor = 'pointer';
        if (row.order === 0) {
          upCursor = 'not-allowed';
        } else if (row.order === highestOrder) {
          downCursor = 'not-allowed';
        }

        return (
          <ReorderArrowControls
            onUp={this.sortRows.bind(this, 'up', i)}
            onDown={this.sortRows.bind(this, 'down', i)}
          />
        );
      },
    },
    {
      key: 'dropdown',
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      items: [
        {
          name: 'Edit',
          handler: (row) => {
            this.handleRowEdit(row);
          },
        },
        {
          name: 'Remove',
          hideWhen: (row) => !row.custom_field,
          handler: (row) => {
            return this.checkFieldCanBeDeleted(row.id).then((canBeDeleted) => {
              if (canBeDeleted) {
                return new GeckoDialogService()
                  .confirm('Are you sure you want to remove this field?')
                  .then((result) => {
                    if (result) {
                      this.deleteField(row.id);
                    }
                  });
              }
            });
          },
        },
      ],
    },
  ].filter(Boolean);

  checkFieldCanBeDeleted(fieldId) {
    return GeckoRequest.post(`/fields/${fieldId}/can-delete`)
      .then(() => true)
      .catch(renderError);
  }

  sortRows(direction, i, e) {
    e.stopPropagation();
    let rows = JSON.parse(JSON.stringify(this.props.fields));
    if (GeckoLocation.params.page && GeckoLocation.params.page > 1) {
      i += 20 * (GeckoLocation.params.page - 1);
    }

    if (
      (direction === 'up' && i > 0) ||
      (direction === 'down' && i < rows.length - 1)
    ) {
      let to;
      if (direction === 'up' && i > 0) {
        to = i - 1;
      } else if (direction === 'down' && i < rows.length) {
        to = i + 1;
      }
      // Change row order
      rows.splice(to, 0, rows.splice(i, 1)[0]);

      //Save row order
      const orderArray = rows.map((row) => {
        return row.id;
      });

      GeckoRequest.post('/fields/order', { order: orderArray }).catch(
        renderError
      );
    }
  }

  headerBtns = [
    {
      preset: GECKO_CONSTS.BTN_PRESET_ADD,
      handler: this.renderAddModal.bind(this),
    },
  ];

  handleRowEdit(row) {
    const field = this.props.fields.find((field) => field.id === row.id);
    this.renderEditModal(field);
  }

  deleteField(id) {
    const newFieldsNo = this.props.fields.length - 1;
    GeckoRequest.delete(`/models/fields/${id}`)
      .then(() => {
        new GeckoToastService().success('Field removed');
        this.changePage(newFieldsNo);
      })
      .catch(renderError);
  }

  changePage(newFieldsNo) {
    let currentPage;
    this.props.params && this.props.params.page
      ? (currentPage = this.props.params.page)
      : (currentPage = 1);
    if (currentPage !== Math.ceil(newFieldsNo / 20)) {
      GeckoLocation.goTo('/settings/customfields', {
        page: Math.ceil(newFieldsNo / 20),
      });
    }
  }

  renderEditModal(field) {
    new GeckoLoadingService()
      .resolve(getOptionsUsedIfSelectType(field))
      .then((valuesUsedInWorkflows) => {
        new GeckoModalService().open(
          () => {
            return (
              <CustomFieldEditModal
                field={field}
                usedValues={valuesUsedInWorkflows}
              />
            );
          },
          { backdrop: 'static' }
        );
      });
  }

  renderAddModal() {
    new GeckoModalService().open(
      () => {
        return <CustomFieldEditModal />;
      },
      { backdrop: 'static' }
    );
  }

  onSearch(term) {
    GeckoLocation.goTo(
      '/settings/customfields',
      Object.assign({}, this.props.params, { search: term })
    );
  }

  render() {
    const [fields, pagination] = GeckoPagination.paginate({
      page: this.props.params.page,
      order_by: this.props.params.order_by || 'order',
      sort: this.props.params.sort || 'ASC',
      searchTerm: this.props.params.search,
      searchKey: 'label',
    })(this.props.fields);
    let rows = JSON.parse(JSON.stringify(fields));
    rows = rows.map((row) => {
      row.friendlyType = this.typeMap[row.type];
      return row;
    });

    return (
      <div className="content-margin">
        <GeckoCardTable
          name="Custom Fields"
          headerBtns={this.headerBtns}
          rows={rows}
          cols={this.cols}
          rowHandler={this.handleRowEdit.bind(this)}
          pagination={pagination}
          onSearch={this.onSearch.bind(this)}
          headerProps={{ searchPlaceholder: 'Search custom fields' }}
        ></GeckoCardTable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    params: state.location.params,
    defaultHeaders: state.appState.defaultHeaders,
    user: state.appState.loggedInUser,
    account: state.appState.account,
    fields: state.fields,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomFields);
